import { BaseModel } from "@blue-chip/core";
import Spec from "./Spec";

export default class UnitOfMeasure extends BaseModel {
  static get hasMany() {
    return [Spec];
  }
}
